import React from 'react';
import { FormApi } from 'final-form';
import Input, { Select, SelectItem, PINInput, AmountInput } from 'ui/Input';
import { onlyNCharacters, onlyNumbers } from 'utils/formatters';
import { IAccount } from 'store/accounts.model';
import { IFormValues, IHandleFieldsChange } from './ManualEntry.model';

type FormType = FormApi<IFormValues, Partial<IFormValues>>;

export const renderSourceAccountField = (accounts: IAccount[], submitting: boolean) => (
  <Select name="sourceAccount" label="Source Account" disabled={submitting}>
    {accounts.map(({ accountNumber }) => (
      <SelectItem value={accountNumber} key={accountNumber}>
        {accountNumber}
      </SelectItem>
    ))}
  </Select>
);

export const renderCustomerIdField = (
  values: IFormValues,
  form: FormType,
  submitting: boolean,
  name: string,
  handleFieldsChange: IHandleFieldsChange,
) => {
  const handleBlur = () => {
    handleFieldsChange();
  };

  return (
    <Input
      name={`${name}.customerId`}
      label="customer ID"
      onBlur={handleBlur}
      disabled={submitting}
    />
  );
};

export const renderCardsLastFourDigitsField = (
  submitting: boolean,
  name: string,
) => (
  <Input
    name={`${name}.cardLastDigit`}
    label="Card's last 4 digits"
    disabled={submitting}
    fieldProps={{
      parse: (value: string) => onlyNCharacters(4)(onlyNumbers(value)),
    }}
  />
);

export const renderAmountField = (submitting: boolean, name: string) => (
  <AmountInput
    name={`${name}.amount`}
    label="Amount"
    disabled={submitting}
  />
);

export const renderNarrationField = (submitting: boolean, name: string) => (
  <Input
    name={`${name}.narration`}
    label="Narration"
    disabled={submitting}
  />
);

export const renderPhoneNumberField = (name: string) => (
  <Input
    name={`${name}.phoneNumber`}
    label="Phone Number"
    disabled
  />
);

export const renderCardNameField = (name: string) => (
  <Input
    name={`${name}.beneficiaryName`}
    label="Card Name"
    disabled
  />
);


export const renderManualEntryToFields = (
  name: string,
  values: IFormValues,
  accounts: IAccount[],
  form: FormApi<IFormValues, Partial<IFormValues>>,
  submitting: boolean,
  handleFieldsChange: IHandleFieldsChange,
) => (
  <>
    {renderCustomerIdField(values, form, submitting, name, handleFieldsChange)}
    {renderPhoneNumberField(name)}
    {renderCardNameField(name)}
    {renderCardsLastFourDigitsField(submitting, name)}
    {renderAmountField(submitting, name)}
    {renderNarrationField(submitting, name)}
  </>
);

export const renderPinField = () => <PINInput name="pin" label="Enter PIN" />;
